<div class="search-field">
  <input autofocus id="search-field-input" class="search-input" type="text" [(ngModel)]="this.search" (keydown)="onKeydown($event)" (input)="onSearchChange(this.search)" placeholder="search...">
  <div class="search-button-wrapper">
    <button mat-icon-button aria-label="Clear" (click)="clearSearch();">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
